import React, { useContext, useEffect, useState } from "react";
import Sidenav from "../components/sidenav";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import BottomNav from "../components/global/BottomNav";
import ChangeTheme from "../components/global/ChangeTheme";
import { ThemeContext } from "../context/ThemeStore";
import UserAuthProfile from "../components/global/UserAuthProfile";

const Dashboard = ({ children }) => {
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(ThemeContext);

  const isLms = sessionStorage.getItem("lms");

  const isSolutionsPage = () => {
    const solutionsPattern = /^\/solutions\/.*$/;
    return solutionsPattern.test(location.pathname);
  };

  const handleAuthRedirect = () => {
    navigate(`/auth?redirect_url=${location.pathname + location.search}`);
  };

  useEffect(() => {
    if (!Cookies.get("token") && !sessionStorage.getItem("token")) {
      handleAuthRedirect();
    }
    const user = JSON.parse(localStorage.getItem("userProfile"));
    if (user && !user.isOnboardingDone && !isLms) navigate(`/onboarding?step=1`);
  }, []);

  return (
    <div>
      <UserAuthProfile />
      {!isLms && <Sidenav />}
      <ChangeTheme isLms={isLms} />
      <div className="main-content mb-5 mb-sm-0 pb-4 pb-sm-0">{children}</div>
      {!isLms && !isSolutionsPage() && <BottomNav />}
    </div>
  );
};

export default Dashboard;
